import { Routes } from '../api-routes'
import { OrganizationDTO } from '../dtos/organization'
import { getPath, setP } from './helpers'

export namespace DemoRoutes {
  export namespace get {
    export function call() {
      return `/${Routes.Demo}`
    }
    export type Response = { organizations: OrganizationDTO[] }
  }

  export namespace reset {
    export function call(p = setP(['organizationId'])) {
      return getPath(p, { suffix: 'reset', prefix: Routes.Demo })
    }
    export type Response = { success: true }
  }
}
